import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import * as _ from "lodash";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PpsUtilityService } from "../services/pps-utility.service";
import { EmployeeBase } from "../shared/models/employee-base";
import { IWorkArea } from "../shared/models/workarea";

@Component({
  selector: "pps-workarea-form",
  templateUrl: "./workarea-form.component.html"
})
export class WorkareaFormComponent implements OnInit{
  presetColors = [
    "#5B9BD5", "#CCCCFF", "FF9900", "#0066FF", "#9933FF",
    "#FF0066", "#00FFFF", "#617099", "#28F0A0", "#FEC2F1", 
    "#DC4264", "#FF66FF", "#FFFF00", "#92D050"
  ];  
  workArea: IWorkArea;
  employees: EmployeeBase[] = [];

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _dlgConfig: DynamicDialogConfig,
    private _util: PpsUtilityService) {
    this.setData(this._dlgConfig.data);
  }
  
  setData(data: any){
    this.employees = _.cloneDeep(data.employees);
    this.workArea = _.cloneDeep(data.workArea);
  }

  ngOnInit(): void {
  }

  save(form: NgForm){
    if (form.invalid){
      return false;
    }

    this._dialogRef.close(this.workArea);
  }

  cancel(){
    this._dialogRef.close();
  }  
}